
import {
  VehicleServicesSearchFormValues,
  VehicleServicesEditFormValues,
  VehicleServicesDetailFormValues,
} from "./types";


/*-------------------------------------------------------------------------------------------
CALCULATION SETTING - VEHICLE SERVICES SEARCH
---------------------------------------------------------------------------------------------*/
export const initialVehicleServicesSearchForm: VehicleServicesSearchFormValues =
  {
    search: "",
  };

/*-------------------------------------------------------------------------------------------
CALCULATION SETTING - VEHICLE SERVICES EDIT
---------------------------------------------------------------------------------------------*/
export const initialVehicleServicesEditForm: VehicleServicesEditFormValues =
  {
    name: null,
    ratePerKm: null,
  };

/*-------------------------------------------------------------------------------------------
    CALCULATION SETTING - TOLL - DETAIL
---------------------------------------------------------------------------------------------*/

export const initialVehicleServicesDetailForm: VehicleServicesDetailFormValues =
  {
    id: null,
    name: null,
    ratePerKm: null,
  };
